import { useState } from 'react';
import './SearchCourse.css';
import SearchIcon from '@mui/icons-material/Search';

export default function SearchCourse(props) {
    const [searchedText, setSearchedText] = useState('');    
    
    function handleOnChange(e) {        
        setSearchedText(e.target.value);        
        const filteredTrainingList = props.trainingList.filter(obj => obj.courseName.toLowerCase().includes(e.target.value.toLowerCase()));        
        props.setFilteredTrainingListStatus(1);
        props.setFilteredTrainingList(filteredTrainingList);                
    }

    function handleOnClick() {
        setSearchedText('');        
        props.setFilteredTrainingListStatus(0);
        props.setFilteredTrainingList([]);
    }

    return <>
        {
            props.trainingList.length > 0 && <div className='search-section'>
                <input type='text' value={searchedText} onChange={handleOnChange} placeholder='Search courses...'/>
                {searchedText.length < 1 && <SearchIcon className='search_icon'/>}                
                {searchedText.length !== 0 && <span className='close-icon' onClick={handleOnClick}>X</span>}
            </div>
        }
    </>
}